import { Card, Text, Input, SimpleGrid, Textarea } from '@mantine/core';
import { useCarePlanFormContext } from '../ClientDetailsSection';

interface NoteCardProps {
  noteType: 'noteCoord' | 'noteCaregiver';
  title?: string;
}

export const NoteCard: React.FC<NoteCardProps> = ({ noteType, title = '' }) => {
  const form = useCarePlanFormContext();

  return (
    <Card shadow="sm" padding="md" radius="md" withBorder>
      <Text fw={700} size="xl">
        {title}
      </Text>

      <SimpleGrid className="mt-3">
        <Input.Wrapper>
          <Textarea
            rows={8}
            variant="filled"
            radius="md"
            placeholder="Poznámka je prázdná..."
            style={{
              height: '185px',
            }}
            {...form.getInputProps(noteType)}
            data-testid={`note-${noteType}`}
          />
        </Input.Wrapper>
      </SimpleGrid>
    </Card>
  );
};
